import { ExternalLink } from "lucide-react";

const initials = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

function Avatar({ person }) {
  if (person.img) {
    return (
      <img
        src={person.img}
        alt={person.name}
        loading="lazy"
        className="h-12 w-12 rounded-full object-cover ring-1 ring-[#0b1f4d]/15 shrink-0"
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className="h-12 w-12 rounded-full grid place-items-center bg-[#f5b61c]/15 text-[#8a5a00] font-display font-semibold text-sm ring-1 ring-[#0b1f4d]/10 shrink-0"
    >
      {initials(person.name)}
    </span>
  );
}

function PersonEntry({ person }) {
  const inner = (
    <>
      <Avatar person={person} />
      <span className="min-w-0">
        <span className="block font-semibold text-[#0b1f4d] truncate">
          {person.name}
        </span>
        <span className="block text-xs font-mono uppercase tracking-widest text-[#66718d]">
          {person.role}
        </span>
      </span>
      {person.href && (
        <ExternalLink
          size={15}
          className="ml-auto text-[#66718d] group-hover:text-[#9a6700] transition-colors shrink-0"
        />
      )}
    </>
  );

  const base =
    "flex items-center gap-3 rounded-md border border-[#0b1f4d]/10 bg-white px-4 py-3";

  if (person.href) {
    return (
      <a
        href={person.href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`participant-link-${person.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        className={`group ${base} transition-colors hover:border-[#f5b61c]/60`}
      >
        {inner}
      </a>
    );
  }
  return (
    <div
      data-testid={`participant-${person.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={base}
    >
      {inner}
    </div>
  );
}

export default function Participants({ persons }) {
  if (!persons || persons.length === 0) return null;
  return (
    <section data-testid="episode-participants" className="mt-10">
      <h2 className="font-display uppercase text-2xl font-semibold text-[#0b1f4d] mb-5">
        Participants in this Episode:
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {persons.map((p, i) => (
          <PersonEntry key={`${p.name}-${i}`} person={p} />
        ))}
      </div>
    </section>
  );
}
